/* "Laad meer producten": haalt de volgende pagina op en voegt de productkaarten toe.
   Werkt samen met facets.js — dat vervangt #ProductGridContainer (incl. <sk-load-more>)
   bij filteren/sorteren, waarna dit custom element opnieuw upgrade (connectedCallback). */
class SkLoadMore extends HTMLElement {
  connectedCallback() {
    if (this._initialized) return;
    this._initialized = true;
    this.section = this.dataset.section;
    this.loading = false;
    this.btn = this.querySelector('.sk-loadmore__btn');
    this.shownEl = this.querySelector('.sk-loadmore__shown');
    this.countEl = this.querySelector('.sk-loadmore__count');
    if (this.btn) this.btn.addEventListener('click', () => this.loadMore());
    this.updateCount();
  }

  get grid() {
    return document.getElementById('product-grid');
  }

  updateCount() {
    const grid = this.grid;
    if (this.shownEl && grid) {
      this.shownEl.textContent = grid.querySelectorAll('.grid__item').length;
    }
  }

  async loadMore() {
    if (this.loading || !this.btn || !this.btn.dataset.url) return;
    this.loading = true;
    this.btn.classList.add('is-loading');
    this.btn.setAttribute('aria-busy', 'true');

    // Doelraster vastleggen vóór de fetch, zodat we een stale resultaat kunnen herkennen.
    const grid = this.grid;

    try {
      const url = this.btn.dataset.url;
      const sep = url.indexOf('?') === -1 ? '?' : '&';
      const fetchUrl = this.section
        ? url + sep + 'section_id=' + encodeURIComponent(this.section)
        : url;

      const response = await fetch(fetchUrl);
      if (!response.ok) throw new Error('HTTP ' + response.status);
      const text = await response.text();

      // Afbreken als dit element of het raster intussen is vervangen
      // (bijv. door een filter/sortering die #ProductGridContainer herrenderde).
      if (!this.isConnected || grid !== this.grid) return;

      const doc = new DOMParser().parseFromString(text, 'text/html');
      const newItems = Array.from(doc.querySelectorAll('#product-grid .grid__item'));
      newItems.forEach((item) => {
        item.classList.add('scroll-trigger--cancel');
        grid.appendChild(item);
      });

      // Volgende pagina overnemen, of de knop verwijderen op de laatste pagina.
      const nextBtn = doc.querySelector('.sk-loadmore__btn');
      if (nextBtn && nextBtn.dataset.url) {
        this.btn.dataset.url = nextBtn.dataset.url;
      } else {
        this.btn.remove();
        this.btn = null;
        // Focus niet naar <body> laten vallen: verplaats naar de (zichtbare) telling,
        // die via aria-live ook het nieuwe totaal aankondigt.
        if (this.countEl) {
          this.countEl.setAttribute('tabindex', '-1');
          this.countEl.focus();
        }
      }

      this.updateCount();
    } catch (error) {
      console.error('Laad meer producten faalde:', error);
    } finally {
      this.loading = false;
      if (this.btn) {
        this.btn.classList.remove('is-loading');
        this.btn.removeAttribute('aria-busy');
      }
    }
  }
}

if (!customElements.get('sk-load-more')) {
  customElements.define('sk-load-more', SkLoadMore);
}
